import React, { useContext, useRef, useEffect, useReducer } from "react";
import { RBCardView } from "../../components/RBCardView";
import { Spacing, Colors, FontSize } from "../../theme/Theme";
import { RBModal } from "../../components/RBModal";
import {RBShiftAgreementModal } from "../../components/RBShiftAgreementModal";
import {
  Select,
  MenuItem,
  Typography,
  Checkbox,
  ListItemText,
  FormControlLabel,
  FormControl,
  IconButton,
  Link,
  TextField,
  FormHelperText
} from "@material-ui/core";
import { formatWorkerType } from "../../util/FormattingService";
import {
  EmptyString,
  Claims,
  ErrorMessages,
  NotAvailableString,
  IndustryModeEnum,
  roleNameEnum,
  ApprovalModeEnum
} from "../../util/Common";
import { ColumnStyle, skillTextStyle } from "../../theme/ComponentTheme";
import { LabelText } from "../../util/TextConstant";
import {
  RBMoneyAmountTextField,
  RBTextField,
} from "../../components/RBTextField";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { RBButton, RBButtonType } from "../../components/RBButton";
import {
  RenderTextWithTitle,
  renderTextWithTitleForSkills,
  renderTextWithTitleAndChildComponent,
  titleHeaderTextStyle,
  detailTextStyle,
} from "../../components/TextWithHeader";
import {
  detailKmAllowanceIcon,
  detailAccomodationAllowanceIcon,
  techOnSiteIcon,
  assistantOnSiteIcon,
  allowofferIcon
} from "../../util/Icons";
import { RBDateTimePicker } from "../../components/RBDateTimePicker";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  workerTypeEnum,
  HelperPageTitleEnum,
  SkillType,
} from "../../util/Enumeration";
import moment from "moment-timezone";
import { Add, Remove } from "@material-ui/icons";
import { RBExternalHelpLink } from "../../components/RBExternalHelpLink";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { AuthService } from "../../api/AuthService";
import { PharmacyService } from "../../api/PharmacyService";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { SkillResponseDto, SkillPayloadDto } from "../../dtos/Skill.dto";
import { ShiftRelatedConstants, defaultWorkDays,defaultEndTimeNew,defaultStartTimeNew } from "../../util/ShiftConstants";
import { CreateShiftDto, ShiftTimeDto } from "../../dtos/CreateShift.dto";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { RBContext } from '../../components/RBContext';
import { ShiftService} from '../../api/ShiftService'
import PDFViewer from "../../components/PdfViewer";
import SignaturePad  from "../../components/SignaturePad"


import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import RBPlacementFeeModal from "../../components/RBPlacementFeeModal";
import { showOnHoldAlert } from "../../util/showOnHoldAlert";
import { AccountInfoContext } from "../../components/AccountInfoContext";


interface CreateDentalShiftPageProps {
  history: any;
  location: any;
}
enum CreateShiftState {
  Create,
  Confirm,
}

interface multipleShiftsProps {
  id: number;
  startTime: moment.Moment;
  endTime: moment.Moment;
  offsets:{startTime:any,endTime:any};
  deviceStartTime: moment.Moment;
  deviceEndTime: moment.Moment;
  startTimeValidation:any;
  endTimeValidation:any;
}
interface IState {
  pharmacyName: string;
  pharmacyId: string;
  showModal: boolean;
  workerType: string;
  wage: string;
  wageInvalidErrorText: string;
  kmAllowance: string;
  accomodationAllowance: string;
  technicianOnSite: boolean;
  assistantOnSite: boolean;
  isDiscardAlertShowing: boolean;
  discardAlertSInfo: AlertInfoProps;
  currentCreateShiftState: CreateShiftState;
  comment: string;
  multipleShifts: multipleShiftsProps[];
  agreeTOS: boolean;
  isPageLoading: boolean;
  isSubmitting: boolean;
  rxCount: string;
  submitErrorMessage?: ErrorMessageProps;
  pharmacyTimeZone: string;
  minimumWage: ObjectLiteral;
  allowOfferChangeOption:boolean;
  allowOffer:boolean;
  isAllowanceEnabled:boolean;
  signature?: string;
  showContract:boolean;
  networkId:string;
  commissionType:string;
  rbCommission:any;
  pharmacy:any;
  showTermOfService:boolean;
  workerTypesAndRates:ObjectLiteral;
  workerTypes:ObjectLiteral;
  isCreateShiftSubmitInfo: boolean;
  createShiftSubmitInfo: AlertInfoProps;
  alertInfo:AlertInfoProps;
  isAlertShowing:boolean;
  resumeModal:boolean;
  newFile:any,
  ownerData:ObjectLiteral,
  workertypeInvalidErrorText: string;
  allSkills: [], // All skills from API
  selectedSkillsByType: any, // e.g., { software: [skillObj], specialization: [skillObj] }
  currentSkillType: null, // For modal switching
  requiredFlagsByType: any,
  accountInfo:any;
  savedSkillOptionsByType: any,
  isFixedHourlyRate: boolean;
  isLoading: boolean;
}

function CreateDentalShiftPageInner(props: CreateDentalShiftPageProps) {
  const context = useContext(RBContext);
  const { accountInformation } = useContext(AccountInfoContext);

  // Mirrors the old `excludedDates: any = []` class field: a mutable array that
  // persists across renders without itself triggering one.
  const excludedDatesRef = useRef<any[]>([]);

  // --- State handling -------------------------------------------------------
  // Class components let every method read `this.state` synchronously right
  // after a `this.setState(...)` call (outside of React's batched event
  // handling). Plain `useState` does NOT give you that: the variable from
  // `useState` only updates on the *next* render. To keep the large amount of
  // sequential, synchronous-looking logic below working exactly as it did
  // before, we keep the "live" value in a ref (`stateRef.current`, read the
  // same way `this.state` was) and use `forceRender` to trigger a re-render
  // whenever it changes - this is a deliberate 1:1 behavioral port, not the
  // idiomatic long-term shape for this component.
  const stateRef = useRef<IState>({
    pharmacyName: EmptyString,
    pharmacyId: EmptyString,
    rxCount: EmptyString,
    showModal: true,
    wage: "0",
    wageInvalidErrorText: EmptyString,
    kmAllowance: "0",
    accomodationAllowance: "0",
    workerType: EmptyString,
    technicianOnSite: false,
    assistantOnSite: false,
    isDiscardAlertShowing: false,
    discardAlertSInfo: {},
    isCreateShiftSubmitInfo:false,
    createShiftSubmitInfo:{},
    comment: EmptyString,
    pharmacyTimeZone: "UTC",
    currentCreateShiftState: CreateShiftState.Create,
    multipleShifts: [],
    agreeTOS: false,
    isPageLoading: true,
    isSubmitting: false,
    minimumWage: {},
    allowOfferChangeOption:false,
    allowOffer:false,
    isAllowanceEnabled:true,
    signature:undefined,
    showContract:false,
    networkId:'',
    commissionType:'',
    rbCommission:null,
    pharmacy:{},
    showTermOfService:false,
    workerTypesAndRates:[],
    workerTypes:[],
    alertInfo:{},
    isAlertShowing:false,
    resumeModal:false,
    newFile:null,
    ownerData:{},
    workertypeInvalidErrorText: EmptyString,
    allSkills: [],
    selectedSkillsByType: {},
    currentSkillType: null,
    requiredFlagsByType: {},
    accountInfo:null,
    savedSkillOptionsByType: {},
    isFixedHourlyRate: false,
    isLoading: false,
  });

  const [, forceRender] = useReducer((x: number) => x + 1, 0);

  // setState(patch) or setState(prevState => patch) - same call shape as the
  // class version, minus the optional callback-after-update second argument
  // (every call site below that used the callback form has been inlined
  // instead; see the comments at those call sites).
  const setState = (
    patch: Partial<IState> | ((prev: IState) => Partial<IState>)
  ) => {
    const patchObj =
      typeof patch === "function"
        ? (patch as (prev: IState) => Partial<IState>)(stateRef.current)
        : patch;
    stateRef.current = { ...stateRef.current, ...patchObj };
    forceRender();
  };

  useEffect(() => {
    (async () => {
      await fetchCreateShiftStatus();
      await fetchAndSetData();
    })();
    // Intentionally empty - matches the original componentDidMount, which
    // only ran once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setAlertState = (newState: any) => {
    setState(newState);
  };
  const fetchCreateShiftStatus = async () => {
    if (!accountInformation) return;

    setState({ showModal: false ,isLoading: true})
    const account = accountInformation;
    const isRegionalManager =
      AuthService.getRoleName() === roleNameEnum.regionalmanager;
    const activePharmacyId = isRegionalManager
      ? localStorage.getItem("regionalManagerSelectedLocationId") ||
        account.owner.defaultPharmacyId
      : account.owner.defaultPharmacyId;
    const dentalOffice = account.pharmacies.filter((pharmacy: any) =>
      pharmacy.id === activePharmacyId
    )[0];
     let title = context.industryMode === IndustryModeEnum.Dentistry ? 'dental practice' : 'company';

    if (dentalOffice.approval.status !== 'approved') {

      setState({
        alertInfo: {
          title: `This ${title} is under review`,
          message: `You can post shifts under this ${title} once it gets approved.`,
          buttons: [

            <RBButton
              key={"confirm"}
              onClick={async () => {
                setState({ isAlertShowing: false });
                props.history.push('/dashboard');
              }}
              buttonBackgroundColor={context.primaryColor}
              color="primary"
              text="Ok"
            />,
          ],
        }
      });
      setState({ isAlertShowing: true });
      setState({ isLoading: false });
      return;
    } else if (dentalOffice.approval?.approvalMode === ApprovalModeEnum.OnHold) {
       const { primaryColor, contactEmail } = context;
            showOnHoldAlert({
              setAlertState: setAlertState,
              primaryColor,
              contactEmail,
              page:'dashboard',
              navigation: props.history
            });
      setState({ isLoading: false });
      return;
    }

    if (!dentalOffice.shiftPostFlag) {
      setState({ isLoading: false });
      setState({
        alertInfo: {
          title: "Contact Network Admin",
          message: `Please contact network admin ${context.contactEmail} or ${context.contactPhone}  to post shift.`,
          buttons: [

            <RBButton
              key={"confirm"}
              onClick={async () => {
                setState({ isAlertShowing: false });
                props.history.push('/dashboard');
              }}
              buttonBackgroundColor={context.primaryColor}
              color="primary"
              text="Ok"
            />,
          ],
        }
      });
      setState({ isAlertShowing: true });
      return;
    }


    if (dentalOffice.paymentType === null && account.networks[0].paymentConfig.paymentEnabled) {
      setState({ isAlertShowing: true });
      setState({alertInfo:{
        title: "Payment Info Required",
        message: `You must set up your payment information before you can post a shift. Would you like to do this now?`,
        buttons: [

          <RBButton
            key={"confirm"}
            onClick={async () => {
              setState({ isAlertShowing: false });
              props.history.push('/paymentOption/',{
                tabType: 'Shift'
              });
            }}
            buttonBackgroundColor={context.primaryColor}
            color="primary"
            text="Yes"
          />,
          <RBButton
            key={"confirm"}
            onClick={async () => {
              setState({ isAlertShowing: false });
              props.history.push('/dashboard');
            }}
            buttonBackgroundColor={context.primaryColor}
            color="primary"
            text="No"
          />,
        ],
      }});

       setState({ isLoading: false });
      
      return;
    }

    setState({ showModal: true, isLoading: false });
  }

  const fetchAndSetData = async () => {

    if (!accountInformation) return;

    setState({ isPageLoading: true });
    const userData = accountInformation;
    const { locationSkillSets , shiftSkillSets } = userData.networks[0].skillSet;
    const skillSet = [...locationSkillSets, ...shiftSkillSets]
    const allSkills = await PharmacyService.fetchSkills(skillSet, context.industryMode); 

    const workerTypes = await AuthService.getAllWorkers(context.industryMode);
    const sortedDataArray = workerTypes;
    sortedDataArray.sort((a:any, b:any) => a.orderSort - b.orderSort);

    const pharmacy = userData.owner.defaultPharmacyId
      ? userData.pharmacies.filter(
          (pharmacy: any) => pharmacy.id === userData.owner.defaultPharmacyId
        )[0]
      : userData.pharmacies[0];
    
    const selectedSkillsByType:any = {};
    const requiredFlagsByType:any = {};
    const savedSkillOptionsByType:any = {};
    locationSkillSets.forEach((type:any) => {
      const skill = pharmacy.skills.filter((s:any) => s.type === type);
      if (skill.length) {
        selectedSkillsByType[type] = skill;
        requiredFlagsByType[type] = false;
        savedSkillOptionsByType[type] = skill;

      }
    });
      
    const nextShifts = await getNextWorkDay(pharmacy);

    setState({
      pharmacyId: pharmacy.id,
      pharmacyName: pharmacy.name,
      rxCount: pharmacy.rxCount,
      technicianOnSite: pharmacy.technicianOnSite,
      assistantOnSite: pharmacy.assistantOnSite,
      multipleShifts: [nextShifts],
      pharmacyTimeZone: pharmacy.address.timezone,
      allowOfferChangeOption:pharmacy.allowOfferChangeOption,
      allowOffer:pharmacy.allowOffer,
      isAllowanceEnabled:
        pharmacy.defaultShiftAccomodationAllowance > 0 ||
        pharmacy.defaultShiftKmAllowance > 0,
      signature:userData.owner.signature,
      networkId:userData.networks[0].id,
      commissionType:pharmacy.commissionType,
      pharmacy:pharmacy,
      workerTypes:sortedDataArray,
      ownerData:userData.owner,
      allSkills:allSkills.data,
      selectedSkillsByType,
      accountInfo:userData,
      requiredFlagsByType,
      savedSkillOptionsByType,
      isFixedHourlyRate: pharmacy.isFixedHourlyRate || false,
      // originally set via setState's second-argument callback; merged into
      // this single update since nothing here depends on an intermediate render
      isPageLoading: false,
    });
  };



  const getNextWorkDay = async (data: any) => {
     const { multipleShifts } = stateRef.current;
     let currentDate = moment().tz(data.address.timezone);
     const currentDay = currentDate.format('dd');
     let currentTime = currentDate.format('HH:mm');
     const isWorkday = data.defaultWorkWeek ? data.defaultWorkWeek.includes(currentDay) :defaultWorkDays.includes(currentDay);
 
     const defaultStartTime = moment(data.defaultStartTime ? data.defaultStartTime :defaultStartTimeNew, 'h:mm A');
     const defaultEndTime = moment(data.defaultEndTime? data.defaultEndTime: defaultEndTimeNew, 'h:mm A');
     const formattedDefaultStartTime = defaultStartTime.format('HH:mm');
     const defaultStarthour = defaultStartTime.hour();
     const defaultStartminutes = defaultStartTime.minute();
 
     const defaultEndhour = defaultEndTime.hour();
     const defaultEndminutes = defaultEndTime.minute(); 
 
     let newStartHour, newStartMin,newEndHour, newEndMin, momentStartTime, momentEndTime;
     if(multipleShifts.length > 0){
       momentStartTime = moment(multipleShifts[multipleShifts.length - 1].deviceStartTime, 'h:mm A')
       newStartHour = momentStartTime.hours(); 
       newStartMin = momentStartTime.minutes(); 
 
       momentEndTime = moment( multipleShifts[multipleShifts.length - 1].deviceEndTime, 'h:mm A')
       newEndHour = momentEndTime.hours(); 
       newEndMin = momentEndTime.minutes(); 
     }
     let lastShiftEndDate:any = null;
     let lastShiftStartDate:any = null;
     if (multipleShifts.length > 0) {
      lastShiftStartDate = moment(multipleShifts[multipleShifts.length - 1].startTime).tz(data.address.timezone);
      lastShiftEndDate = moment(multipleShifts[multipleShifts.length - 1].endTime).tz(data.address.timezone);
    }
 
     let nextWorkStartday = lastShiftStartDate
         ? lastShiftStartDate.clone().add(1, 'days').format('dd')
         : currentDate.format('dd');
     let nextWorkEndday = lastShiftEndDate
         ? lastShiftEndDate.clone().add(1, 'days').format('dd')
         : currentDate.format('dd');
 
     let initialStartDate, initialEndDate;
     let newStartDate = moment().tz(data.address.timezone); 
     let newEndDate = moment().tz(data.address.timezone); 
     currentTime = newStartDate.format('HH:mm');
 
     let daysToStartAdd = multipleShifts.length === 0 ? 0 : 1;
     let daysToEndAdd = multipleShifts.length === 0 ? 0 : 1;
     if (isWorkday && multipleShifts.length === 0) {
       if (currentTime < formattedDefaultStartTime) {
         daysToStartAdd = 0;
         daysToEndAdd = 0;
       }
       else{
         daysToStartAdd = 1;
         daysToEndAdd = 1;
       }
     }
     while (data.defaultWorkWeek ? !data.defaultWorkWeek.includes(nextWorkStartday) :!defaultWorkDays.includes(nextWorkStartday)) {
       daysToStartAdd += 1;
       nextWorkStartday = moment(lastShiftStartDate ? lastShiftStartDate : currentDate).clone().add(daysToStartAdd, 'days').format('dd');
     }
 
     while (data.defaultWorkWeek ? !data.defaultWorkWeek.includes(nextWorkEndday) :!defaultWorkDays.includes(nextWorkEndday)) {
       daysToEndAdd += 1;
       nextWorkEndday = moment(lastShiftEndDate ? lastShiftEndDate : currentDate).clone().add(daysToEndAdd, 'days').format('dd');
     }
 
     if (isWorkday) {
       if (currentTime < formattedDefaultStartTime) {
         initialStartDate = multipleShifts.length !== 0 ?
           lastShiftStartDate.clone().add(daysToStartAdd, 'days').set('hour', newStartHour).set('minute', newStartMin).set('second', 0) :
           currentDate.set('hour', defaultStarthour).set('minute', defaultStartminutes).set('second', 0);
         initialEndDate = multipleShifts.length !== 0 ?
           lastShiftEndDate.clone().add(daysToEndAdd, 'days').set('hour', newEndHour).set('minute', newEndMin).set('second', 0) :
           currentDate.clone().set('hour', defaultEndhour).set('minute', defaultEndminutes).set('second', 0)
 
       } else {
 
         initialStartDate = multipleShifts.length === 0 ?
         newStartDate.add(daysToStartAdd, 'days').set('hour', defaultStarthour).set('minute', defaultStartminutes).set('second', 0) :
           lastShiftStartDate.clone().add(daysToStartAdd, 'days').set('hour', newStartHour).set('minute', newStartMin).set('second', 0);
         initialEndDate = multipleShifts.length === 0 ?
         newEndDate.clone().add(daysToEndAdd, 'days').set('hour', defaultEndhour).set('minute', defaultEndminutes).set('second', 0) :
           lastShiftEndDate.clone().add(daysToEndAdd, 'days').set('hour', newEndHour).set('minute', newEndMin).set('second', 0);
 
       }
     }
     else {
 
       initialStartDate = multipleShifts.length === 0 ?
       newStartDate.clone().add(daysToStartAdd, 'days').set('hour', defaultStarthour).set('minute', defaultStartminutes).set('second', 0) :
         lastShiftStartDate.clone().add(daysToStartAdd, 'days').set('hour', newStartHour).set('minute', newStartMin).set('second', 0);
       initialEndDate = multipleShifts.length === 0 ?
       newEndDate.clone().add(daysToEndAdd, 'days').set('hour', defaultEndhour).set('minute', defaultEndminutes).set('second', 0) :
         lastShiftEndDate.clone().add(daysToEndAdd, 'days').set('hour', newEndHour).set('minute', newEndMin).set('second', 0);
 
     }

    let startDateValidation = null;
    let endDateValidation = null;
    if (multipleShifts.length > 0)
    {
      let minimumStartTime = minDate();
      if ( moment(initialStartDate).isBefore(minimumStartTime)) {
        startDateValidation  = "Enter valid start time";
      } else {
        startDateValidation  = null;
      }

      let newStartTime =  initialStartDate;
      const minimumEndTime = newStartTime.clone().add(5, 'minutes');
      const maxEndTime = maxDate(newStartTime.clone());
      if ( moment(initialEndDate).isBefore(minimumEndTime)) {
        endDateValidation = "Enter valid end time";
      } else if ( moment(initialEndDate).isAfter(maxEndTime)) {
        endDateValidation = "Enter valid end time";
      } else {
        endDateValidation = null;
      }
    }
 
     const newShiftEntry = { 
       id:multipleShifts.length == 0 ? 0 : multipleShifts[multipleShifts.length-1].id + 1,
       startTime: initialStartDate,
       endTime: initialEndDate,
       offsets: {
                 startTime: moment(initialStartDate)
                   .tz(data.address.timezone)
                   .utcOffset(),
                 endTime: moment(initialEndDate)
                   .tz(data.address.timezone)
                   .utcOffset(),
               },
       deviceStartTime: initialStartDate,
       deviceEndTime:initialEndDate,
       startTimeValidation:startDateValidation,
       endTimeValidation:endDateValidation,
     }
     return newShiftEntry;
   };
  const setShowTermOfService = (showTermOfService: boolean) =>
    setState({ showTermOfService });

  const contractPreviewClick = () => {
    setState({showContract:true})
  }
  const onContractClose = () => {
    setState({showContract:false})
  }
  const onTermsClose = () => {
    setState({showTermOfService:false})
  }
  const onResumeClose = () => {
    setState({resumeModal :false})
   };
  const onClose = () => {
    const { currentCreateShiftState } = stateRef.current;

    if (currentCreateShiftState === CreateShiftState.Create) {
      goBackToPreviousLocation();
    } else {
      setState({
        discardAlertSInfo: {
          title: "Discard Shift",
          message: "Are you sure you want to discard the change?",
          buttons: [
            <RBButton
              key={RBButtonType.cancel}
              buttonType={RBButtonType.cancel}
              onClick={() => {
                setState({ isDiscardAlertShowing: false });
              }}
              text="Cancel"
            />,
            <RBButton
            buttonBackgroundColor={context.primaryColor}
              key={"Discard"}
              onClick={() => {
                setState({ isDiscardAlertShowing: false });
                goBackToPreviousLocation();
              }}
              color="primary"
              text="Discard"
            />,
          ],
        },
        isDiscardAlertShowing: true,
      });
    }
  };

  const goBackToPreviousLocation = () => {
    if (props.location.state && props.location.state.background) {
      setState({ showModal: false });
      props.history.goBack();
    } else {
      setState({ showModal: false });
      props.history.push("/dashboard");
    }
  };

  const onChange = (key: string, value: any) => {
    console.log(`key is ${key}, value is ${value}`);
  };
  const updateWorkerType = async (event: any) => {
    console.log(`updateWorkerType, value is ${event.target.value}`);
    const workerTypesAndRates = await AuthService.getActiveWorkerTypeMinimumRate(event.target.value);

    const { accountInfo, selectedSkillsByType } = stateRef.current;
    const { shiftSkillSets } = accountInfo.networks[0].skillSet;

    const updatedSkillsByType = Object.fromEntries(
      Object.entries(selectedSkillsByType).filter(
        ([key]) => !shiftSkillSets.includes(key)
      )
    );

    setState({
      workerType: event.target.value,
      wage: "0",
      wageInvalidErrorText: EmptyString,
      workertypeInvalidErrorText: EmptyString,
      workerTypesAndRates:workerTypesAndRates,
      selectedSkillsByType: updatedSkillsByType,
    });
  };
  const isWageValid = () => {
    const { wage, workerType, workerTypesAndRates } = stateRef.current;
    const getMinimumWage = () => {
       const { workerType, workerTypesAndRates } = stateRef.current;
      if (workerTypesAndRates && workerTypesAndRates.workerType === workerType) {
        return (workerTypesAndRates.shiftMinimumRate || 0) / 100;
      }

      return 100;
    };
  
    const lowerBound = getMinimumWage();

    setState({
      wageInvalidErrorText:
        Number(wage) >= lowerBound
          ? EmptyString
          : `The minimum rate is $${lowerBound.toFixed(2)}`,
    });

    return Number(wage) >= lowerBound;
  };
  const renderPharmacyName = () => {
    const { pharmacyName } = stateRef.current;
    return (
      <Typography variant="h6" style={{ textAlign: "center" }}>
        {pharmacyName}
      </Typography>
    );
  };
  const plusPressed = async () => {
    const { multipleShifts, pharmacyTimeZone,pharmacy } = stateRef.current;
    let newMultipleShifts:any = [];
    for (let index = 0; index < multipleShifts.length; index++) {
      newMultipleShifts.push({
        id: index,
        startTime: multipleShifts[index].startTime,
        endTime: multipleShifts[index].endTime,
        offsets: {
          startTime: moment()
            .tz(pharmacyTimeZone)
            .utcOffset(),
          endTime: moment()
            .tz(pharmacyTimeZone)
            .utcOffset(),
        },
        deviceStartTime: multipleShifts[index].deviceStartTime,
        deviceEndTime: multipleShifts[index].deviceEndTime,
        startTimeValidation:multipleShifts[index].startTimeValidation,
        endTimeValidation:multipleShifts[index].endTimeValidation
      });
    }
    const nextShifts = await getNextWorkDay(pharmacy);
    newMultipleShifts.push(nextShifts)
    setState({ multipleShifts: newMultipleShifts });
  };
  const removePressed = (shiftNoId: number) => {
    const { multipleShifts } = stateRef.current;
    multipleShifts.splice(shiftNoId, 1);

    const newMultipleShifts = [];
    for (let index = 0; index < multipleShifts.length; index++) {
      newMultipleShifts.push({
        id: index,
        startTime: multipleShifts[index].startTime,
        endTime: multipleShifts[index].endTime,
        offsets: multipleShifts[index].offsets,
        deviceStartTime: multipleShifts[index].deviceStartTime,
        deviceEndTime: multipleShifts[index].deviceEndTime,
        startTimeValidation:multipleShifts[index].startTimeValidation,
        endTimeValidation:multipleShifts[index].endTimeValidation,
      });
    }
    setState({ multipleShifts: newMultipleShifts });
  }

  const getDateTime = (date: any) => {
    let currentDate = moment(date)
    let year = currentDate.format('YYYY')
    let month = currentDate.format('MM')
    let day = currentDate.format('DD')
    let hour = currentDate.format('HH')
    let minute = currentDate.format('mm')
    let second = currentDate.format('ss')
    let convertedDate = moment(year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second);
    return convertedDate;
  }

  const convertOffsetToString = (offset: any) => {
    let value = '';
    const absOffset = Math.abs(offset);
    const hr = absOffset / 60;
    const min = absOffset % 60;
    if (offset < 0) {
      value = value + '-';
    }
    else {
      value = value + '-';
    }
    if (hr < 10) {
      value = value + '0' + hr;
    }
    else {
      value = value + hr;
    }
    if (min < 10) {
      value = value + ':0' + min;
    }
    else {
      value = value + ':' + min;
    }
    return value;
  }

  const getNextWorkingDay = (date: any) => {
    const { pharmacy } = stateRef.current;
    let nextDate = moment(date).add(24, "hours");
    let nextDay = nextDate.format('dd');

    while (pharmacy.defaultWorkWeek ? !pharmacy.defaultWorkWeek.includes(nextDay): !defaultWorkDays.includes(nextDay)) {
      nextDate = moment(nextDate).add(24, "hours");
      nextDay = nextDate.format('dd');
    }

    return nextDate;
  };

  const isWeekday = (date: any) => {
    const { pharmacy } = stateRef.current;
    const dayOfWeek = moment(date).format('dd');
     
     return pharmacy.defaultWorkWeek.includes(dayOfWeek);
  };


  const minDate = () => {
    const { pharmacy } = stateRef.current;
    let currentDate = moment().tz(pharmacy.address.timezone);
    let currentDay  = currentDate.format('dd');

    while (pharmacy.defaultWorkWeek ? !pharmacy.defaultWorkWeek.includes(currentDay): !defaultWorkDays.includes(currentDay)) {
      currentDate = currentDate.add(1, 'day');
      currentDay  = currentDate.format('dd');

    }

    return moment(currentDate)
  }


  const maxDate = (startDate: any) => {
    const { pharmacy } = stateRef.current;
    let newDate = getNextWorkingDay(startDate);
    let currentDate = moment(startDate).add(1, 'day');

    while (currentDate.isBefore(newDate)) {
      if (!pharmacy.defaultWorkWeek.includes(currentDate)) {
        excludedDatesRef.current.push(currentDate.toDate());
      }
      currentDate = currentDate.add(1, 'day');
    }
    console.log("min start time",moment(getDateTime(minDate())).toDate())
    console.log(" min time", moment(getDateTime(startDate)).toDate())
    console.log("max time", moment(getDateTime(newDate)).toDate())
    return moment(newDate)
  }

  const renderMultipleShiftsTime = () => {
    const { multipleShifts, pharmacyTimeZone } = stateRef.current;
    console.log("renderMultipleShiftsTime ", multipleShifts, pharmacyTimeZone);
    return (
      <>
        {multipleShifts.map((shift,index) => (
          <div key={shift.id} style={{ marginBottom: Spacing.small }}>
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
                Shift No. {shift.id + 1}
              </Typography>
              <RBEmptyBlock />
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "flex-end",
                }}
              >
                {index === 0 ? (
                  <IconButton size={"small"} onClick={() => plusPressed()}>
                    <Add style={{ color: Colors.themeBlue }} />
                  </IconButton>
                ) : (
                  <IconButton
                    size="small"
                    onClick={() => removePressed(shift.id)}
                  >
                    <Remove style={{ color: Colors.themeGreen }} />
                  </IconButton>
                )}
              </div>
            </div>
            <div
              style={{
                ...ColumnStyle, alignItems: "center"
              }}
            >
              <div style={{display: "flex", flex: 1}}>
              <DatePicker
                selected={moment(getDateTime(shift.deviceStartTime)).toDate()}
                onChange={(date) => {
                  const { multipleShifts } = stateRef.current;
                  const newMultipleShifts = [];
                  for (let index = 0; index < multipleShifts.length; index++) {
                    newMultipleShifts.push({
                      id: index,
                      startTime: multipleShifts[index].startTime,
                      endTime: multipleShifts[index].endTime,
                      offsets: multipleShifts[index].offsets,
                      deviceStartTime: multipleShifts[index].deviceStartTime,
                      deviceEndTime: multipleShifts[index].deviceEndTime,
                      startTimeValidation:multipleShifts[index].startTimeValidation,
                      endTimeValidation:multipleShifts[index].endTimeValidation,
                    });
                  }
                  let newShift = newMultipleShifts[shift.id];
                  const offsetString1 = convertOffsetToString(newShift.offsets.startTime)
                  newShift.deviceStartTime = date ? moment(date) : moment()
                  newShift.startTime = date ? moment(moment(date).format('YYYY-MM-DDTHH:mm:ss') + offsetString1) :
                    moment(moment().format('YYYY-MM-DDTHH:mm:ss') + offsetString1)
                 
                  const momentStartTime = moment(shift.deviceEndTime, 'h:mm A')
                  const newStartHour = momentStartTime.hours(); 
                  const newStartMin = momentStartTime.minutes(); 
                  newShift.endTime  = moment(moment(moment(date).set('hour', newStartHour).set('minute', newStartMin).set('second', 0)).format('YYYY-MM-DDTHH:mm:ss')+ offsetString1);
                  newShift.deviceEndTime  = moment(date).set('hour', newStartHour).set('minute', newStartMin).set('second', 0);

                  let UtcOffsetForCondition = moment.tz(newShift.startTime, pharmacyTimeZone)
                  if (multipleShifts[shift.id].offsets['startTime'] !== UtcOffsetForCondition.utcOffset()) {
                    const newOffset = multipleShifts[shift.id].offsets['startTime'] - UtcOffsetForCondition.utcOffset();
                    newShift.startTime.add(newOffset, 'minutes')
                    newShift.endTime.add(newOffset, 'minutes')
                    newShift.offsets['startTime'] = UtcOffsetForCondition.utcOffset();
                    newShift.offsets['endTime'] = moment.tz(newShift.endTime, pharmacyTimeZone).utcOffset()
                  }
                 
                  let minimumStartTime = minDate();
                  if (moment(newShift.startTime).isBefore(minimumStartTime)) {
                    newShift.startTimeValidation = "Enter valid start time";
                    newShift.endTimeValidation = null;
                  } else {
                    newShift.startTimeValidation = null;
                    newShift.endTimeValidation = null;
                  }

                  const maxEndTime = moment(maxDate(newShift.startTime));
                  const minEndTime = moment(moment(date).format('YYYY-MM-DDTHH:mm:ss') + offsetString1).add(5,"minutes");
                  if (moment(newShift.endTime).isBefore(moment(minEndTime))) {
                   newShift.endTimeValidation = "Enter valid end time";
                  } else if (moment(newShift.endTime).isAfter(maxEndTime)) {
                    newShift.endTimeValidation = "Enter valid end time";
                  } else {
                    newShift.endTimeValidation = null;
                  }

                  setState({ multipleShifts: newMultipleShifts });
                }}
                showTimeSelect
                minDate={minDate().toDate()}
                timeFormat="h:mm aa"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="eee, MMM do yyyy h:mm aa"
                customInput={
                  <input
                    style={{
                      paddingTop: Spacing.medium,
                      paddingBottom: Spacing.medium,
                      paddingRight: "20%",
                      borderRadius:5,
                      borderColor:"rgb(220 220 220)",
                      width: 260,
                      fontSize:15
                    }}
                    key={`dateTime-${pharmacyTimeZone}`}
                  />
                }
                withPortal
                filterDate={isWeekday}
              />
              </div>
              <RBEmptyBlock />
              <div style={{display: "flex", flex: 1}}>
              <DatePicker
                selected={moment(getDateTime(shift.deviceEndTime)).toDate()}
                onChange={(date) => {
                  console.log(
                    `RBDateTimePicker shift ${shift.id} end time ${date}`
                  );
                  const { multipleShifts } = stateRef.current;
                  const newMultipleShifts = [];
                  for (let index = 0; index < multipleShifts.length; index++) {
                    newMultipleShifts.push({
                      id: index,
                      startTime: multipleShifts[index].startTime,
                      endTime: multipleShifts[index].endTime,
                      offsets: multipleShifts[index].offsets,
                      deviceStartTime: multipleShifts[index].deviceStartTime,
                      deviceEndTime: multipleShifts[index].deviceEndTime,
                      startTimeValidation:multipleShifts[index].startTimeValidation,
                      endTimeValidation:multipleShifts[index].endTimeValidation,
                    });
                  }
                  let newShift = newMultipleShifts[shift.id];
                  newShift.offsets['endTime'] = moment.tz(newShift.endTime, pharmacyTimeZone).utcOffset()
                  const offsetString2 = convertOffsetToString(newShift.offsets.endTime)
                  newShift.deviceEndTime = date ? moment(date) : moment()
                  newShift.endTime = date ? moment(moment(date).format('YYYY-MM-DDTHH:mm:ss') + offsetString2) :
                    moment(moment().format('YYYY-MM-DDTHH:mm:ss') + offsetString2)
                  let UtcOffsetForCondition = moment.tz(newShift.endTime, pharmacyTimeZone)
                  if(multipleShifts[shift.id].offsets['endTime'] !==  UtcOffsetForCondition.utcOffset())
                  {
                    newShift.offsets['endTime'] = newShift.endTime.utcOffset();
                  }
                  
                  const maxEndTime = moment(maxDate(shift.startTime));
                  const minEndTime = moment(shift.startTime).add(5,"minutes");
                  if (moment(newShift.endTime).isBefore(moment(minEndTime))) {
                   newShift.endTimeValidation = "Enter valid end time";
                  } else if (moment(newShift.endTime).isAfter(maxEndTime)) {
                    newShift.endTimeValidation = "Enter valid end time";
                  } else {
                    newShift.endTimeValidation = null;
                    }

                  setState({ multipleShifts: newMultipleShifts });
                }}
                showTimeSelect
                minDate={
                  moment(getDateTime(shift.deviceStartTime)).toDate()
                }
               maxDate={maxDate(shift.deviceStartTime).toDate()}
                timeFormat="h:mm aa"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="eee, MMM do yyyy h:mm aa"
                customInput={
                  <input
                    style={{
                      paddingTop: Spacing.medium,
                      paddingBottom: Spacing.medium,
                      borderRadius:5,
                      borderColor:"rgb(220 220 220)",
                      width: 260, 
                      fontSize:15
                    }}
                    key={`dateTime-${pharmacyTimeZone}`}
                  />
                }
                withPortal
                excludeDates={excludedDatesRef.current}
              />
              </div>
             
            </div>
            <div
              style={{
                ...ColumnStyle, alignItems: "center"
              }}
            >
              <div style={{display: "flex", flex: 1}}>
              {shift.startTimeValidation && (
                              <Typography variant="caption" color="error" style={{ marginLeft: 20 ,marginBottom:"8px"}}>
                                {shift.startTimeValidation}
                              </Typography>
                            )}
              </div>
              <div style={{display: "flex", flex: 1}}>
              {shift.endTimeValidation && (
                              <Typography variant="caption" color="error" style={{ marginLeft: 20 }}>
                                {shift.endTimeValidation}
                              </Typography>
                            )}
              </div>

            </div>
          </div>
        ))}
      </>
    );
  };
  const renderWorkerType = () => {
    const { workerType ,workerTypes,workertypeInvalidErrorText} = stateRef.current;
    return (
      <div style={{ ...ColumnStyle, alignItems: "center" }}>
        <Typography style={{ display: "flex", flex: 1 }}>
          Worker Type
        </Typography>
        <RBEmptyBlock />
        <FormControl
          variant="outlined"
          size={"small"}
          style={{ display: "flex", flex: 1 }}
        >

        <Select
          value={workerType}
          displayEmpty
          renderValue={workerType !== "" ? undefined : () => "Select"}
          onChange={updateWorkerType}>
          {workerTypes.map((value:any) => (
            <MenuItem value={value.workerType} key={value.workerType}>
              {value.displayName}
            </MenuItem>
          ))}
        </Select>
        {workertypeInvalidErrorText !== EmptyString && <FormHelperText error>{workertypeInvalidErrorText}</FormHelperText>}
        </FormControl>
      </div>
    );
  };
  const capitalize = (str: any) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  
  const renderLocationSkills = () => {
      const { selectedSkillsByType , requiredFlagsByType, accountInfo,savedSkillOptionsByType } = stateRef.current;
     const { locationSkillSets,locationMultiSelects } = accountInfo.networks[0].skillSet;
  
    return locationSkillSets.map((type:any) => {
      const skills = selectedSkillsByType[type] || [];
      const required = requiredFlagsByType[type] || false;
      const requiredColor = required ? context.secondaryColor : Colors.darkGrey;
      const isMultiSelect = locationMultiSelects.includes(type);

      const options = savedSkillOptionsByType[type] || [];


      const selectedIds = isMultiSelect
        ? skills.map((s: any) => s.id)
        : skills.length > 0 ? skills[0].id : "";

      return(
        <>
          {!isMultiSelect ?
            <div style={{ ...ColumnStyle, alignItems: "center" }}>
              <Typography style={{ display: "flex", flex: 1 }}>
                {capitalize(type)}
              </Typography>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                  color: required
                    ? context.secondaryColor
                    : Colors.darkGrey,
                }}
                control={
                  <Checkbox
                    checked={required}
                    style={{
                      color: required
                        ? context.secondaryColor
                        : Colors.darkGrey,
                    }}
                    onChange={() =>
                      setState(prevState => ({
                        requiredFlagsByType: {
                          ...prevState.requiredFlagsByType,
                          [type]: !required,
                        },
                      }))
                    }
                  />
                }
                label={<Typography> {skills.length
                  ? skills.map((s: any) => s.name).join(', ')
                  : 'None selected'}</Typography>}
              />
            </div>
            :

            <div style={{ ...ColumnStyle, alignItems: "center", marginTop: -Spacing.medium }}>
              <Typography style={{ display: "flex", flex: 1 }}>
                {capitalize(type)}
              </Typography>
              <RBEmptyBlock />
              <FormControl variant="outlined" size="small" style={{ display: "flex", flex: 1 }}>
                <Select
                  multiple={isMultiSelect}
                  value={selectedIds}
                  onChange={(event) => {
                    const value = event.target.value;
                    const selectedIdsArray: any = isMultiSelect ? value : [value];
                    const selectedSkills = options.filter((s: any) =>
                      selectedIdsArray.includes(s.id)
                    );

                    setState(prevState => ({
                      selectedSkillsByType: {
                        ...prevState.selectedSkillsByType,
                        [type]: selectedSkills,
                      },
                    }));
                  }}
                  displayEmpty
                  renderValue={(selected) => {
                    const selectedArray: any = isMultiSelect ? selected : [selected];
                    const selectedNames = options
                      .filter((s: any) => selectedArray.includes(s.id))
                      .map((s: any) => s.name);
                    return selectedNames.length > 0 ? selectedNames.join(', ') : 'Add Skills';
                  }}
                >
                  {options.map((skill: any) => (
                    <MenuItem key={skill.id} value={skill.id}>
                      {isMultiSelect && (
                        <Checkbox
                          checked={selectedIds.includes(skill.id)}
                          style={{
                            color: selectedIds.includes(skill.id)
                              ? context.secondaryColor
                              : Colors.darkGrey,
                          }}
                        />
                      )}
                      <ListItemText primary={skill.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          }


          <div
            style={{
              ...ColumnStyle,
              alignItems: "center",
              marginTop: Spacing.smallest,
            }}
          >
            <Typography style={{ display: "flex", flex: 1 }}></Typography>
            <RBEmptyBlock />
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                fontSize: 12,
                textAlign: "start",
              }}
            >
             *Select if {type} is mandatory
            </div>
          </div>
        </>
      )
       });
    }

  const renderPharmacySpecific = () => {
    return (
        renderLocationSkills()
    );
  };

  const renderWage = () => {
    const { wage, wageInvalidErrorText,allowOfferChangeOption ,allowOffer,workertypeInvalidErrorText} = stateRef.current;
    return (
      <>
        <div
          style={{
            ...ColumnStyle,
            alignItems: "center",
            paddingBottom: Spacing.smallest,
          }}
        >
          <Typography style={{ display: "flex", flex: 1,color:"red" }}>
            Hourly Rate Offered
          </Typography>
          <RBEmptyBlock />
          <RBMoneyAmountTextField
            name="currency"
            value={wage}
            onChange={(event) =>
              {
              setState({
                wage:
                  event.target.value == "0.00" ? "0" : event.target.value,
              })
              if(stateRef.current.workerType === EmptyString || stateRef.current.workerType === "Select"){
                setState({workertypeInvalidErrorText :"Please select a worker type"})
              }

            }
            }
            error={wageInvalidErrorText.length > 0}
            errorText={wageInvalidErrorText}
          />
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            textAlign: "start",
            fontSize: 12,
            color:"red"
          }}
        >
          {Claims.shiftCommission}
        </div>

        {allowOfferChangeOption && <>
        <div
          style={{
            ...ColumnStyle,
            alignItems: "center",
            paddingBottom: Spacing.smallest,
          }}
        >
          <Typography style={{ display: "flex", flex: 1}}>
          Allow rate offers?
          </Typography>
          <RBEmptyBlock />
            <FormControlLabel
              style={{
                display: "flex",
                flex: 1,
              }}
              control={
                <Checkbox
                  checked={allowOffer}
                />
              }
              label={EmptyString}
            />
          </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            textAlign: "start",
            fontSize: 12,
          }}
        >
          {Claims.Allow_Offers_Description}
        </div>
        </>}

      </>
    );
  };
  const renderAllowance = () => {
    const { kmAllowance, accomodationAllowance,isAllowanceEnabled } = stateRef.current;
    return (
      <>
        <div style={{ ...ColumnStyle, alignItems: "center" }}>
          <Typography style={{ display: "flex", flex: 1 }}>
            Commute Allowance
          </Typography>
          <RBEmptyBlock />
          <FormControlLabel
            style={{
              display: "flex",
              flex: 1,
            }}
            control={
              <Checkbox
                checked={isAllowanceEnabled}
                style={{
                  color: stateRef.current.isAllowanceEnabled
                    ? context.secondaryColor
                    : Colors.darkGrey,
                }}
                onChange={() =>
                  setState({
                    isAllowanceEnabled: !stateRef.current.isAllowanceEnabled,
                  })
                }
              />
            }
            label={EmptyString}
          />

        </div>
        {isAllowanceEnabled && <>
        <div style={{ ...ColumnStyle, alignItems: "center" }}>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {detailKmAllowanceIcon(context.primaryColor)}
            <div style={{ marginLeft: Spacing.small }}>Per Km</div>
          </div>
          <RBEmptyBlock />
          <RBMoneyAmountTextField
            name="currency"
            inputProps={{
              style: {
                paddingTop: Spacing.smaller,
                paddingBottom: Spacing.smaller,
              },
            }}
            onChange={(event) =>
              setState({
                kmAllowance:
                event.target.value == "0.00" ? "0" : event.target.value,
              })
            }
            value={kmAllowance}
          />
        </div>

        <div style={{ ...ColumnStyle, alignItems: "center" }}>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: 4,
              marginRight: -4,
            }}
          >
            {detailAccomodationAllowanceIcon(context.primaryColor)}
            <div style={{ marginLeft: Spacing.small }}>Per Shift</div>
          </div>
          <RBEmptyBlock />

          <RBMoneyAmountTextField
            inputProps={{
              style: {
                paddingTop: Spacing.smaller,
                paddingBottom: Spacing.smaller,
              },
            }}
            onChange={(event) =>
              setState({
                accomodationAllowance:
                event.target.value == "0.00" ? "0" : event.target.value,
              })
            }
            value={accomodationAllowance}
          />
        </div>
        </>
        }
      </>
    );
  };

  const renderComment = () => {
    const { comment } = stateRef.current;
    return (
      <>
        <div style={{ ...ColumnStyle, alignItems: "center" }}>
          <Typography style={{ display: "flex", flex: 1 }}>Comments</Typography>
        </div>
        <RBTextField
          style={{
            display: "flex",
            flex: 1,
            paddingTop: Spacing.small,
            paddingBottom: Spacing.small,
          }}
          placeholder={"*Please add any important details about the shift(s) so the temps can understand the expectations before applying."}
          value={comment}
          onChange={(event) => setState({ comment: event.target.value })}
          multiline
          rows={3}
          rowsMax={8}
        />
      </>
    );
  };
  const handleShiftSkillChange = (type: string, selectedIds: string[]) => {
    const { allSkills } = stateRef.current;

    if (!selectedIds.length || selectedIds[0] === "") {
      setState((prevState) => ({
        selectedSkillsByType: {
          ...prevState.selectedSkillsByType,
          [type]: [],
        },
      }));
      return;
    }

    const selectedSkills = allSkills.filter(
      (skill: any) => selectedIds.includes(skill.id) && skill.type === type
    );
  
    setState((prevState) => ({
      selectedSkillsByType: {
        ...prevState.selectedSkillsByType,
        [type]: selectedSkills,
      },
    }));
  };
  
  const renderShiftSkills = () => {
    const { selectedSkillsByType, allSkills, accountInfo, workerType } = stateRef.current;
    const { shiftSkillSets,isWorkerTypeDependent,shiftMultiSelects } = accountInfo.networks[0].skillSet;
  
    return shiftSkillSets.map((type: string) => {
      const selectedSkillIds = (selectedSkillsByType[type] || []).map((s: any) => s.id);
      const options = allSkills.filter(
        (s: any, index: number, self: any[]) =>
          s.type === type &&
          (
          !isWorkerTypeDependent || s.pharmacistType === workerType
        ) &&
          index === self.findIndex((t) => t.id === s.id)
      );
       const isMultiSelect = shiftMultiSelects.includes(type);
  
      return (
        <div key={type}>
          <div style={{ ...ColumnStyle, alignItems: "center" }}>
            <Typography style={{ display: "flex", flex: 1 }}>
              {capitalize(type)} {type === 'specialization' ? 'Skills': ''}
            </Typography>
            <RBEmptyBlock />
            <FormControl
              variant="outlined"
              size="small"
              style={{ display: "flex", flex: 1 }}
            >
              <Select
                multiple={isMultiSelect}
                value={
                  isMultiSelect
                    ? selectedSkillIds
                    : selectedSkillIds.length > 0
                      ? selectedSkillIds[0]
                      : ""
                }
                onChange={(event) => {
                  const value = event.target.value;
                  handleShiftSkillChange(
                    type,
                    isMultiSelect ? (value as string[]) : [value as string]
                  );
                }}
                displayEmpty
                renderValue={(selected) => {
                  const selectedArray = isMultiSelect
                    ? (selected as string[])
                    : [selected as string];

                  if (!selectedArray.length || !selectedArray[0]) {
                    return "Add Skills";
                  }
                  return (
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {selectedArray.map((id) => {
                        const skill: any = options.find((s: any) => s.id === id);
                        return (
                          <div key={id} style={{ ...skillTextStyle }}>
                            {skill?.name || id}
                          </div>
                        );
                      })}
                    </div>
                  );
                }}
              >
                {!isMultiSelect && (
                  <MenuItem value="">
                    Select
                  </MenuItem>
                )}
                {options.map((skill:any) => (
                  <MenuItem key={skill.id} value={skill.id}>
                    {isMultiSelect && (
                      <Checkbox
                        checked={selectedSkillIds.includes(skill.id)}
                        style={{
                          color: selectedSkillIds.includes(skill.id)
                            ? context.secondaryColor
                            : Colors.darkGrey,
                        }}
                      />
                    )}
                    <ListItemText primary={skill.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
  
          <div
            style={{
              ...ColumnStyle,
              alignItems: "center",
              marginTop: Spacing.smallest,
              marginBottom: Spacing.small,
            }}
          >
            <Typography style={{ display: "flex", flex: 1 }}></Typography>
            <RBEmptyBlock />
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                fontSize: 12,
                textAlign: "start",
              }}
            >
              *Select only mandatory skills
            </div>
          </div>
        </div>
      );
    });
  };
  

  const previewAllowance = () => {
    const { kmAllowance, accomodationAllowance } = stateRef.current;
    const kmAllowanceNumber = Number(kmAllowance);
    const accomodationAllowanceNumber = Number(accomodationAllowance);
    return (
      <div style={ColumnStyle}>
        {kmAllowanceNumber > 0 && (
          <div style={{ flex: 1, alignItems: "flex-start" }}>
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                ...titleHeaderTextStyle,
              }}
            >
              {detailKmAllowanceIcon(context.primaryColor)}
              <div
                style={{
                  marginLeft: Spacing.smallest,
                }}
              >
                KM Allowance
              </div>
            </div>

            <div style={detailTextStyle}>{"$" + kmAllowance + "/km"}</div>
          </div>
        )}
        {accomodationAllowanceNumber > 0 && (
          <div style={{ flex: 1, alignItems: "flex-start" }}>
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                ...titleHeaderTextStyle,
              }}
            >
              {detailAccomodationAllowanceIcon(context.primaryColor)}
              <div
                style={{
                  marginLeft: Spacing.smallest,
                }}
              >
                Allowance
              </div>
            </div>

            <div style={detailTextStyle}>{"$" + accomodationAllowance}</div>
          </div>
        )}
      </div>
    );
  };

  const previewShiftTimes = () => {
    const { multipleShifts, pharmacyTimeZone } = stateRef.current;
    return (
      <>
        {multipleShifts.map((shift) => {
          const startTimeFormat = shift.startTime
            ? moment(shift.startTime).tz(pharmacyTimeZone).format("h:mm a")
            : "N/A";
          const endTimeFormat = shift.endTime
            ? moment(shift.endTime).tz(pharmacyTimeZone).format("h:mm a")
            : "N/A";
          const dateString = moment(shift.startTime)
            .tz(pharmacyTimeZone)
            .format("ddd, MMMM Do YYYY");
          return (
            <div key={shift.id} style={{ marginBottom: Spacing.small }}>
              <div
                style={{ ...ColumnStyle, marginBottom: 0, paddingBottom: 0 }}
              >
                {RenderTextWithTitle(
                  `Shift No. ${shift.id + 1} Date`,
                  dateString
                )}
                {RenderTextWithTitle(
                  "Time",
                  `${startTimeFormat} - ${endTimeFormat}`
                )}
              </div>
              <div
                style={{
                  borderBottomColor: Colors.defaultGrey,
                  borderBottomWidth: "1px",
                  borderBottomStyle: "solid",
                }}
              />
            </div>
          );
        })}
      </>
    );
  };
  const previewContent = () => {
    const {
      pharmacyName,
      pharmacyId,
      workerType,
      technicianOnSite,
      assistantOnSite,
      kmAllowance,
      accomodationAllowance,
      wage,
      comment,
      rxCount,
      agreeTOS,
      allowOffer,
      signature,
      allowOfferChangeOption,
      multipleShifts,
      commissionType,
      rbCommission,
      isAllowanceEnabled,
      pharmacy,
      showTermOfService,
      networkId,
      resumeModal,
      ownerData,
      newFile,
      accountInfo,
      selectedSkillsByType,
      requiredFlagsByType
    } = stateRef.current;


    const { shiftSkillSets, locationSkillSets } = accountInfo.networks?.[0]?.skillSet;
    const skills:any = [];

    Object.entries(selectedSkillsByType).forEach(([type, skillOrList]) => {
      const skillList = Array.isArray(skillOrList) ? skillOrList : [skillOrList];

      skillList.forEach((skill: any) => {
        if (!skill) return;
        skills.push({
          skillId: skill.id,
          pharmacistType: skill.pharmacistType,
          required: locationSkillSets.includes(type) ? requiredFlagsByType[type] || false : true,
          name: skill.name,
          type: skill.type,
        });
      });
    });

     const skillsByType:any = {};
    skills.forEach((skill:any) => {
      if (!skillsByType[skill.type]) {
        skillsByType[skill.type] = [];
      }
      skillsByType[skill.type].push(skill);
    });

    const locationSkillsByType:any = {};
    locationSkillSets.forEach((type:any) => {
      locationSkillsByType[type] = skillsByType[type] || [];
    });

    const shiftSkillsByType:any = {};
    shiftSkillSets.forEach((type:any) => {
      shiftSkillsByType[type] = skillsByType[type] || [];
    });


    const finalComment = comment.length > 0 ? comment : NotAvailableString;

    const payload = {
      pharmacyName,
      pharmacyId,
      shiftTimes: multipleShifts,
      comment,
      workerWage: (parseFloat(wage) * 100).toFixed(2),
      allowOffers: allowOffer,
      pharmacistType:workerType,
      isAllowanceEnabled,
      kmAllowance: isAllowanceEnabled ? (parseFloat(kmAllowance) * 100).toFixed(2) : 0,
      accomodationAllowance: isAllowanceEnabled
        ? (parseFloat(accomodationAllowance) * 100).toFixed(2)
        : 0,
      actualCommission: pharmacy.commissionType == 'fixed' ? pharmacy.commission : pharmacy.commissionPercentage,
      commissionType:pharmacy.commissionType,
      commissionMinimum:pharmacy.commissionMinimum,
      commissionMaximum:pharmacy.commissionMaximum,
      networkPaid:pharmacy.networkPaid
    };



    const allowanceAvailable =
    Number(accomodationAllowance) > 0 || Number(kmAllowance) > 0;

    return (
      <>
      <RBModal
          open={resumeModal}
          onClose={onResumeClose}
          modalTitle={"Signature"
          }
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
          children={
              rendersignatureContent(signature)
          }
        />
        <div style={ColumnStyle}>
          {RenderTextWithTitle(context.industryMode === IndustryModeEnum.Dentistry ? "Dental Practice" : "Company", pharmacyName)}
        </div>
        {previewShiftTimes()}

        {allowOfferChangeOption ? 
        <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle(
            "Worker Type",
            formatWorkerType(workerType as workerTypeEnum)
          )}
          
        </div>

        <div style={ColumnStyle}>
           {RenderTextWithTitle("Hourly Rate", "$" + wage)}
           {renderTextWithTitleAndChildComponent(
            "Allow rate offers?",
            allowofferIcon(allowOffer,context.secondaryColor)
          )}
        </div>
        </>:
        <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle(
            "Worker Type",
            formatWorkerType(workerType as workerTypeEnum)
          )}
          {RenderTextWithTitle("Hourly Rate", "$" + wage)}
        </div>
        
        </>}


        {allowanceAvailable && previewAllowance()}

         {(locationSkillSets.length === 1 && shiftSkillSets.length === 1) ?
        <div style={ColumnStyle}>
            {renderTextWithTitleForSkills(
              capitalize(locationSkillSets[0]),
              (locationSkillsByType[locationSkillSets[0]] || []).map((skill: any) =>
                skill.required
                  ? skill.name
                  : ShiftService.getUnrequiredSoftwareName?.(skill.name) || skill.name
              )
            )}
            {renderTextWithTitleForSkills(
              capitalize(shiftSkillSets[0]),
              (shiftSkillsByType[shiftSkillSets[0]] || []).map((skill: any) => skill.name)
            )}
        </div>:
        <>
            {Object.entries(locationSkillsByType).map(([type, skills]) => {
              const skillsArray = skills as any[];

              return (
                <div style={ColumnStyle}>
                  {renderTextWithTitleForSkills(
                    capitalize(type),
                    skillsArray.map((skill: any) =>
                      skill.required
                        ? skill.name
                        : ShiftService.getUnrequiredSoftwareName?.(skill.name) || skill.name
                    )
                  )}
                </div>
              ) ;
            })}
            {Object.entries(shiftSkillsByType).map(([type, skills]) => {
              const skillsArray = skills as any[];
              return  (
                <div style={ColumnStyle}>
                  {renderTextWithTitleForSkills(
                    capitalize(type),
                    skillsArray.map((skill: any) => skill.name)
                  )}
                </div>
              );

            })}
        </>
        
        
      }

        <div style={ColumnStyle}>
          {RenderTextWithTitle("Comment", finalComment)}
        </div>
        <div style={ColumnStyle}>
          
            {signature && renderTextWithTitleAndChildComponent("Signature", <Link
               onClick={() => setState({resumeModal :true})}
              style={{ ...detailTextStyle, color: context.primaryColor, cursor: 'pointer'  }}
            >
              {"View"}
            </Link>)}
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              overflowWrap: "anywhere",
              alignItems: "flex-start",
              alignContent: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                flex: 1,
                overflowWrap: "anywhere",

                ...titleHeaderTextStyle,
              }}
            >
             Shift Agreement
            </div>

            <Link
              style={{
                display: "flex",
                flex: 1,
                whiteSpace: "pre-wrap",
                overflowWrap: "anywhere",
                ...detailTextStyle,
                color: context.primaryColor,
                cursor: 'pointer' 
              }}
              onClick={contractPreviewClick}
            >
              Preview
            </Link>
          </div>
        </div>
        {!signature && 
        <>
        <SignaturePad
          isVisible={true}
          onLoad = {(file,dataURL) =>{
            setState({newFile :file})
          }}

          onSave={(file,dataURL) =>{
          }}
          onCancel={() =>{}}
          onClear={() => {
            localStorage.removeItem("workerSign")
            setState({newFile : null})
          }}
          userData = {ownerData}
          page="createShift"
        />
        <div style={{ fontSize: 10 }}>
          *This signature will be saved in your profile as default for
          future usage
        </div>
        </>}

        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignItems: "center",
            marginTop: Spacing.large,
          }}
        >
          <Checkbox
            checked={agreeTOS}
            style={{
              padding: 0,
              paddingRight: Spacing.large,
              marginLeft: -2,
              color: agreeTOS ? context.secondaryColor : Colors.darkGrey,
            }}
            
            onChange={(_, checked) => {
              setState({ agreeTOS: checked });
            }}
          />
          <Typography variant="body2">
            I have read and understood the{" "}
            <Link onClick={() => setShowTermOfService(true)} style={{color:context.primaryColor, cursor: 'pointer',fontWeight:"bold"}}>{HelperPageTitleEnum.termOfService}
            .</Link>
          </Typography>
        </div>
        {showTermOfService && <RBShiftAgreementModal
          open={showTermOfService}
          onClose={onTermsClose}
          modalTitle={"Terms of Service"}
          pageName="terms-of-use"
          pageType="page"
          networkId = {networkId}
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
          />
        }

    
      </>
    );
  };
  const renderShiftContractContent = () => {
    return(
      <div>text</div>
    )
  }
  const renderCreateShiftContent = () => {
    const { currentCreateShiftState } = stateRef.current;

    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
        }}
      >
        {currentCreateShiftState === CreateShiftState.Create && (
          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
            {renderPharmacyName()}
            {renderMultipleShiftsTime()}
            {renderWorkerType()}
            <div style={{ marginTop: Spacing.small }}>
              {renderShiftSkills()}
            </div>
            {renderPharmacySpecific()}
            {renderWage()}
            <div style={{ marginTop: Spacing.small }}>
              {renderAllowance()}
            </div>
            {renderComment()}
          </RBCardView>
        )}
        {currentCreateShiftState === CreateShiftState.Confirm && (
          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              paddingLeft: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
            {previewContent()}
          </RBCardView>
        )}
      </div>
    );
  };

  const isCreateShiftFormValid = () => {
    
    const { multipleShifts, workerType, pharmacyTimeZone } = stateRef.current;
    const reducer = (accumulator: any, currentValue: any) =>
      accumulator && currentValue;
    const isAllShiftTimesValid = multipleShifts
      .map((shift) => {
        const durationAsHours = moment
          .duration(moment(shift.startTime).diff(moment(shift.endTime)))
          .asHours();
        return (
          durationAsHours < 24 &&
          moment(shift.startTime).isBefore(moment(shift.endTime)) && shift.startTimeValidation === null && shift.endTimeValidation === null
        );
      })
      .reduce(reducer, true);
    return isAllShiftTimesValid && workerType !== EmptyString;
  };
  const isPreviewFormValid = () => {
    const { agreeTOS,newFile,signature } = stateRef.current;
    return (agreeTOS && (signature || newFile));
  };

  const onSubmittingCreateShift = async () => {
    const {
      multipleShifts,
      pharmacyId,
      technicianOnSite,
      assistantOnSite,
      wage,
      kmAllowance,
      accomodationAllowance,
      workerType,
      comment,
      pharmacy,
      allowOffer,
      isAllowanceEnabled,
      pharmacyName,
      newFile,
      selectedSkillsByType,
      requiredFlagsByType,
      accountInfo
    } = stateRef.current;

    const {locationSkillSets } = accountInfo.networks?.[0]?.skillSet;
    const skills:any = [];
    Object.entries(selectedSkillsByType).forEach(([type, skillOrList]) => {
      const skillList = Array.isArray(skillOrList) ? skillOrList : [skillOrList];

      skillList.forEach((skill: any) => {
        if (!skill) return;
        skills.push({
          skillId: skill.id,
          pharmacistType: skill.pharmacistType,
          required: locationSkillSets.includes(type) ? requiredFlagsByType[type] || false : true,
          name: skill.name,
          type: skill.type,
        });
      });
    });

    try {
      setState({ isSubmitting: true });
      const shiftTimes: ShiftTimeDto[] = multipleShifts.map((shift) => {
        return {
          id: shift.id,
          startTime: shift.startTime.toISOString(),
          endTime: shift.endTime.toISOString(),
          offsets:shift.offsets

        };
      });
      const payload: CreateShiftDto = {
        pharmacyId: pharmacyId,
        shiftTimes: shiftTimes,
        technicianOnSite: technicianOnSite,
        assistantOnSite: assistantOnSite,
        wage: (Number(wage) * 100).toFixed(2),
        kmAllowance: (Number(kmAllowance) * 100).toFixed(2),
        accomodationAllowance: (Number(accomodationAllowance) * 100).toFixed(2),
        comment: comment,
        pharmacistType: workerType as workerTypeEnum,
        skills: skills,
        actualCommission:pharmacy.commissionType == 'fixed' ? pharmacy.commission : pharmacy.commissionPercentage,
        allowOffers:allowOffer,
        commissionMaximum:pharmacy.commissionMaximum,
        commissionMinimum:pharmacy.commissionMinimum,
        commissionType:pharmacy.commissionType,
        isAllowanceEnabled:isAllowanceEnabled,
        networkPaid:pharmacy.networkPaid,
        pharmacy:pharmacy,
        pharmacyName:pharmacyName,
        isFixedHourlyRate: pharmacy.isFixedHourlyRate

      };
      if (newFile) {
        await AuthService.updateOwner({ signature: newFile });
      }
      const newShift = await PharmacyService.createShift(payload);
      setState({ isSubmitting: false });
      NotificationService.publish(
        NotificationServiceTopic.ShiftChanged,
        newShift.id
      );

      setState({
        createShiftSubmitInfo: {
          title: "Shift Created",
          message: "Your shift has been created.\n\nYou will be notified via email and push notification when you receive new applicants for the shift.",
          buttons: [
            <RBButton
              key={RBButtonType.cancel}
              buttonType={RBButtonType.cancel}
              onClick={() => {
                setState({ showModal: false })
                setState({ isCreateShiftSubmitInfo: false });
                
                props.history.push("/shift/detail/"+ newShift.id)
              }}
              style={{color:"white"}}
              text="View Shift"
              buttonBackgroundColor={context.primaryColor}
            />,
            <RBButton
            buttonBackgroundColor={context.primaryColor}
              key={"Discard"}
              onClick={() => {
                setState({ showModal: false })
                setState({ isCreateShiftSubmitInfo: false });
                props.history.push("/dashboard");
              }}
              color="primary"
              text="Home"
            />,
          ],
        },
        isCreateShiftSubmitInfo: true,
      });

    } catch (err) {
      const errorMessage = err.response ? err.response.data.message : err.message;
      setState({ isSubmitting: false });
      setState({
        submitErrorMessage: errorMessage,
      });
    } finally {
      setState({ isSubmitting: false });
    }
  };
  const renderCreateShiftActions = () => {
    const { currentCreateShiftState,isSubmitting } = stateRef.current;
    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
          alignItems: "flex-end",
        }}
      >
        {currentCreateShiftState === CreateShiftState.Create && (
          <RBButton
            style={{
              display: "flex",
              flex: 1,
              padding: Spacing.medium,
              margin: Spacing.large,
            }}
            buttonBackgroundColor={context.secondaryColor}
            onClick={() => {
              if (isWageValid()) {
                setState({
                  currentCreateShiftState: CreateShiftState.Confirm,
                });
              }
            }}
            disabled={!isCreateShiftFormValid()}
            text="Create Shift"
          />
        )}
        {currentCreateShiftState === CreateShiftState.Confirm && (
          <>
            <RBButton
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
              buttonBackgroundColor={context.secondaryColor}
              onClick={() => {
                setState({
                  currentCreateShiftState: CreateShiftState.Create,
                });
              }}
              
              text="Cancel"
            />
            <RBButton
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
              buttonBackgroundColor={context.secondaryColor}
              onClick={onSubmittingCreateShift}
              disabled={!isPreviewFormValid()}
              text="Confirm"
              isLoading={isSubmitting}
            />
          </>
        )}
      </div>
    );
  };
  const rendersignatureContent = (signature: any) => {
    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
          userSelect:"none",
          pointerEvents:"none"

        }}
      >
        
          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
            <PDFViewer pdfUrl={signature} title="signature"></PDFViewer>
          </RBCardView>
       
      </div>
    );
  };
  const {
      showModal,
      isDiscardAlertShowing,
      discardAlertSInfo,
      currentCreateShiftState,
      isPageLoading,
      showContract,
      networkId,
      workerType,
      pharmacyName,
      wage,
      kmAllowance,
      accomodationAllowance,
      isCreateShiftSubmitInfo,
      createShiftSubmitInfo,
      isAlertShowing,
      alertInfo,
      pharmacyId
    } = stateRef.current;

    const currentDate = moment().format('MMM-DD-YYYY');
    const currentYear = moment().year();
    if (stateRef.current.isLoading) {
      return <LoadingIndicator />
    }

    return (
      <>
        <RBErrorAlert
          show={stateRef.current.submitErrorMessage ? true : false}
          errorMessage={JSON.stringify(stateRef.current.submitErrorMessage, null, 2)}
          onClose={() => {
            setState({ submitErrorMessage: undefined });
          }}
        />
        <RBAlert
          show={isAlertShowing}
          alertTitle={alertInfo?.title}
          alertMessage={alertInfo?.message}
          buttons={alertInfo?.buttons}
        />
        <RBAlert
          show={isDiscardAlertShowing}
          alertTitle={discardAlertSInfo.title}
          alertMessage={discardAlertSInfo.message}
          buttons={discardAlertSInfo.buttons}
        />
         <RBAlert
          show={isCreateShiftSubmitInfo}
          alertTitle={createShiftSubmitInfo.title}
          alertMessage={createShiftSubmitInfo.message}
          buttons={createShiftSubmitInfo.buttons}
        />
        {showContract && <RBShiftAgreementModal
          open={showContract}
          onClose={onContractClose}
          modalTitle="Shift Contract"
          pageName="contract-pharmacy"
          pageType="page"
          networkId = {networkId}
          locationId = {pharmacyId}
          type = 'create'
          substitutions={{
            currentDate,
            currentYear,
            endTime: 'endTime',
            pharmacistDetails: formatWorkerType(workerType as workerTypeEnum),
            pharmacyDetails: pharmacyName,
            shiftNumber: `xxxx-${currentYear}-x-xx`,
            startTime: 'startTime',
            wage: `$${wage}`,
            pharmacistSignature: '',
            pharmacySignature: '',
            licenseNumber: '',
            accredidationNumber: '',
            pharmacistName: workerType,
            pharmacyName: pharmacyName,
            reliefBuddySignature: '',
            workerType: formatWorkerType(workerType as workerTypeEnum),
            kmAllowance: kmAllowance
              ? kmAllowance
              : 0,
            accomodationAllowance: accomodationAllowance
              ? accomodationAllowance
              : 0,
          }}
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
        />}

        <RBModal
          open={showModal}
          onClose={onClose}
          modalTitle={
            currentCreateShiftState === CreateShiftState.Create
              ? "Create Shift"
              : "Confirm Shift"
          }
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
          actions={!isPageLoading && renderCreateShiftActions()}
          children={
            isPageLoading ? (
              <LoadingIndicator />
            ) : (
              renderCreateShiftContent()
            )
          }
        />
      </>
    );
}

export const CreateDentalShiftPage = React.memo(CreateDentalShiftPageInner);
